// extracted by mini-css-extract-plugin
module.exports = {"sp-175w-K":"K_sp-175w-K__KqFZ0"};